import {useContext} from 'react';
import {Context} from '../../context';
import {getAccountBalanceInDollars, assetImgUrl} from '../../helperFunctions';
import HeaderMenu from './HeaderMenu';

const localeDict = {
  en: 'english',
  es: 'español'
};

export default function Header(props) {
  const {account, content, locale, localeText, setLocale, locales} =
    useContext(Context);

  const {className} = props;

  const language = (
    <div>
      {locales
        .filter(l => l !== locale)
        .map((l, index) => (
          <button
            className='font-bold'
            key={index}
            onClick={() => setLocale(l)}
          >
            {localeDict[l][0].toUpperCase() + localeDict[l].slice(1)}
          </button>
        ))}
    </div>
  );

  return (
    <div
      className={`flex justify-between p-4 overflow-visible ${className}`}
      id='topNavigationBar'
    >
      <div className='flex'>
        {assetImgUrl(content, 'logo') && (
          <img
            className='h-full'
            src={assetImgUrl(content, 'logo')}
            alt={localeText('rw_header_alt_agency_logo', 'Agency Logo')}
          />
        )}
        <div className='ml-8 flex flex-col justify-center'>
          <p className='text-3xl my-0 hidden sm:block'>
            {localeText('rw_header_header_agency_name', ' ')}
          </p>
          {account && (
            <p className='font-semibold text-xl my-0'>
              {(account?.transitAccounts?.[0].storedValue && (
                <span>
                  {localeText('rw_header_title_balance', 'Balance')}: $
                  <span id='header-balance'>
                    {getAccountBalanceInDollars(account)}
                  </span>
                </span>
              )) || <span>&nbsp;</span>}
            </p>
          )}
        </div>
      </div>
      <div className='flex lg:flex-col items-center lg:items-end self-end'>
        <div className='flex h-fit gap-2 p-2'>{language}</div>
        <div className='p-2 relative'>
          <HeaderMenu />
        </div>
      </div>
    </div>
  );
}
